module.exports = __webpack_public_path__ + "img/card_chileebuscovid19_background.85f4e3ab.png";